import { useEffect, useState } from "react";
import Snacks from "../../components/Snacks";
import Bio from "./Bio";
import CustomerReviews from "../../components/CustomerReviews";
import PrimaryTabs from "../../components/PrimaryTabs";
import Container from "../../components/Container";
import InfluencerProductsTab from "./InfluencerProductsTab";
import ScheduleTab from "./ScheduleTab";

const Influencer = () => {
  const [snacks, setSnacks] = useState({});
  const tabsInfo = [
    {
      value: "influencer-products",
      text: "Products",
      TapPanelContent: InfluencerProductsTab,
    },
    {
      value: "schedule",
      text: "Schedule",
      TapPanelContent: ScheduleTab,
    },
  ];
  const data = [];
  useEffect(() => {
    const data = import("./snacks.json").then((data) => setSnacks(data));
  }, []);

  return (
    <div className="bg-white">
      <section className="">
        <Container>
          <Bio />
        </Container>
      </section>
      <section className="">
        <Container>
          <PrimaryTabs tabsInfo={tabsInfo} />
        </Container>
      </section>
      <section className="">
        <Container>
          <CustomerReviews />
        </Container>
      </section>
      <section className="">
        <Container
          maxWidth={
            "xs:max-w-full md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]"
          }
          width={"w-full"}
        >
          <Snacks data={snacks}>
            <div className="text-center">
              Check out{" "}
              <strong className="text-[#5f5f5f] font-semibold">
                {snacks && snacks.influencer}
              </strong>
              , hard to find healthy snacks
            </div>
          </Snacks>
        </Container>
      </section>
    </div>
  );
};

export default Influencer;
